<template>
    <div>
        <b-col cols="12 mb-2 mt-3" v-if="item.indumentariasElegidas?.length > 0 && item.observacion_indumentarias">
            <b>Observaciones de las indumentarias:</b> {{ item.observacion_indumentarias }}
        </b-col>
        <div :class="item.activar_pago_plazos && plazos ? 'd-xl-flex justify-content-between' : ''">
            <b-col cols="12" :md="item.activar_pago_plazos && plazos ? '6' : '12'" :xl="item.activar_pago_plazos && plazos ? '6' : '12'" class="table-responsive">
                <table class="table tabla-resumen table-bordered">
                    <tr class="lightgray-content">
                        <th></th>
                        <th>Pedido</th>
                        <th class="price">Precio</th>
                    </tr>

                    <tr>
                        <td class="h1 text-center regular"></td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{ item.titulo }}</strong>
                            <template v-if="item.descripcion">
                                <strong class="text-bold h7 d-block mb-1">{{ item.descripcion }}</strong>
                            </template>
                        </td>
                        <td>
                            <template v-if="item.activar_pago_plazos && plazos?.length">
                                <del class="h5 m-0">
                                    {{ item.precio | formatear_precio }}
                                </del>
                                <h3>{{ plazos[0].importe | formatear_precio }}</h3>
                            </template>
                            <div v-else class="h3 m-0">{{ item.precio | formatear_precio }}</div>
                        </td>
                    </tr>

                    <template v-if="item.indumentariasElegidas?.length > 0">
                        <tr v-for="(indumentaria, index) in item.indumentariasElegidas" :key="index + '-' + indumentaria.id">
                            <td class="text-center"><img :src="indumentaria.imagen" style="width: 50px;" alt=""/></td>
                            <td>
                                <strong class="text-bold h5 d-block mb-1">{{ indumentaria.nombre }} 
                                    <small style="font-size: 11px;">({{ indumentaria.unidades + (indumentaria.unidades > 1 ? ' uds' : (' ud' + (indumentaria.incluida ? ' ' + $t('bases.incluida') : '')))}})</small>
                                </strong>
                                <small><strong class="text-bold h7 d-block mb-1">Talla {{ indumentaria.talla.nombre }}</strong></small>
                            </td>
                            <td>
                                <div class="h3 m-0" v-if="indumentaria.incluida && indumentaria.unidades == 1">{{ '0' | formatear_precio  }}</div>
                                <div class="h3 m-0" v-else>{{ indumentaria.precio_total | formatear_precio }}</div>
                            </td>
                        </tr>
                    </template>

                    <tr>
                        <td colspan="2" style="text-align: right">
                            <span class="total-price h2 m-0">{{ $t('bases.total') }}: </span>
                        </td>
                        <td>
                            <template v-if="item.activar_pago_plazos && plazos">
                                <del class="total-price h5 m-0">{{ item.indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}<span>*</span></del>
                                <div class="h3 m-0">
                                    {{ priceResumen + (!item.price_management_interno_online ? item.price_management_online : 0) | formatear_precio }}*
                                </div>
                            </template>
                            <span v-else class="total-price h2 m-0">{{ item.indumentariasElegidas ? totalConIndumentarias : total | formatear_precio }}<small>*</small></span>
                        </td>
                    </tr>
                </table>
            </b-col>

            <b-col v-if="plazos && item.activar_pago_plazos" :class="!esMovil ? 'table-responsive' : 'table-responsive mt-5'" cols="12" :md="item.activar_pago_plazos && plazos ? '6' : '12'" :xl="item.activar_pago_plazos && plazos ? '6' : '12'">
                <table class="table tabla-resumen table-bordered">
                    <tr>
                        <th class="p-0 pt-1" colspan="3"><h3 class="text-center">{{ $t('bases.plazos') }}</h3></th>
                    </tr>
                    <tr class="lightgray-content">
                        <th></th>
                        <th>{{ $t('bases.fecha') }}</th>
                        <th>{{ $t('bases.importe') }}</th>
                    </tr>
                    <template v-for="(plazo, index) in plazos">
                        <tr :key="index">
                            <td class="pt-2 pb-0 text-center"><h5>{{ plazo.id }}</h5></td>
                            <td class="pt-2 pb-0"><h5>{{ plazo.fecha }}</h5></td>
                            <td class="pt-2 pb-0"><h5>{{ !plazo.price_management_interno ? ($t('bases.importe_plazo', { importe_sin_gd: $n(plazo.importe, "currency"), gd: $n(plazo.price_management, "currency" ) })) : ($n(plazo.importe, "currency")) }}</h5></td>
                        </tr>
                    </template>
                </table>
                <div v-if="item.activar_pago_plazos && plazos" class="border p-2">
                    <b><p class="m-0">{{ $t('bases.info_plazos') }}</p></b>
                </div>
            </b-col>
        </div>

        <b-col v-if="item.activar_pago_plazos" cols="12" class="mt-3 mb-3">
            <AddPlazosComponent
                :frecuencias="item.frecuencias_categorias"
                :min_plazos="item.min_cantidad_plazos"
                :max_plazos="item.max_cantidad_plazos"
                :gastos="item.price_management_online"
                :tiene_gastos="item.price_management_interno_online ? false : true"
                :disabled="loading_plazos"
                :esMovil="esMovil"
                @terminado="calcularPlazos"
                @reset="pagarImporteCompleto"
            />
        </b-col>

        <ResumenPrecioComponnent
            :price_management_interno="item.price_management_interno_online"
            :price_management="item.price_management_online"
            :price="priceResumen"
            :iva="footer.iva_base"
        />

        <div class="col-12 mt-4">
            <FormTerminos
                :error="error"
                :condiciones_plazos="footer.condiciones_bases_plazos"
                :texto_condiciones="texto_condiciones"
                :pago_plazos="item.activar_pago_plazos && plazos"
                :desactivar="loading"
                @continuar="aceptarCondiciones"
            />
        </div>
    </div>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponnent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import AddPlazosComponent from '../compra/plazos/AddPlazosComponent.vue';

    export default {
        props: ["categoria", "esMovil", "base", "loading"],
        data() {
            return {
                error: false,
                plazos: null,
                item: { ...this.categoria },
                privacidad: false,
                condiciones: false,
                condiciones_plazos: false,
                loading_plazos: false,
                texto_condiciones: `
                    <p>1. Las cuotas indicadas ...</p>
                    <p>10. El coste del servicio corresponde a 0,96€ (iva incluido) por cada uno de los plazos de pago solicitados. </p>
                `
            };
        },
        computed: {
            total() {
                return parseFloat(!this.item.price_management_interno_online ? this.item.precio + this.item.price_management_online : this.item.precio);
            },
            totalIndumentarias() {
                let total = 0;
                if (this.item.indumentariasElegidas?.length) {
                    for (let ind of this.item.indumentariasElegidas) {
                        total += (ind.incluida && ind.unidades == 1) ? 0 : parseFloat(ind.precio_total);
                    }
                }
                return total;
            },
            totalConIndumentarias() {
                return this.total + this.totalIndumentarias;
            },
            totalPlazos() {
                let total = 0;
                if (this.plazos) {
                    this.plazos.forEach(plazo => {
                        total += !plazo.price_management_interno ? (plazo.importe + plazo.price_management) : plazo.importe;
                    });
                }
                return total;
            },
            priceResumen() {
                let total = this.plazos?.length ? this.plazos[0].importe : this.item.precio;
                if (this.item.indumentariasElegidas?.length > 0) total += this.totalIndumentarias;
                return total;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            calcularPlazos(data) {
                this.loading_plazos = true;

                if (this.item.indumentariasElegidas?.length > 0) {
                    this.item.importe_total = this.item.price_management_interno_online == 0
                        ? this.totalConIndumentarias - this.item.price_management_online
                        : this.totalConIndumentarias;
                }

                this.item.plazoSelect = data.plazoSelect;
                this.item.frecuenciaSelect = data.frecuenciaSelect;

                const params = {
                    categoria_id: this.item.id,
                    frecuencia_id: data.frecuenciaSelect?.id,
                    n_plazos: data.plazoSelect,
                    session_id: this.item.session_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.bases.calcular-plazos'), params).then(res => {
                    this.plazos = res.data.plazos;
                    this.aceptarCondiciones(false, this.privacidad, this.condiciones, false, this.condiciones_plazos);
                }).finally(() => {
                    this.loading_plazos = false;
                    this.closeModalPlazos('pago-plazos-bases');
                });
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones, plazos) {
                this.privacidad = privacidad;
                this.condiciones = condiciones;
                this.condiciones_plazos = plazos;

                if (continuar) {
                    this.$emit('isAccepted', continuar);
                } else {
                    let hasAccepted = false;
    
                    if (privacidad && condiciones) {
                        hasAccepted = true;
                    }
    
                    if (this.plazos?.length && !plazos) {
                        hasAccepted = false;
                    }
    
                    this.$emit("isAccepted", hasAccepted);
                }
            },
            showModalPlazos(modal) {
                this.$modal.show(modal);
            },
            closeModalPlazos(modal) {
                this.$modal.hide(modal);
            },
            pagarImporteCompleto() {
                this.loading_plazos = true;

                const params = {
                    filters: { tid: this.configuracion.hash_teatro },
                    session_id: this.item.session_id
                };
                this.$store.dispatch(this.config.getVuexAlias('front.bases.borrar-plazos-carrito'), params).then(res => {
                    this.plazos = null;
                    this.item.frecuenciaSelect = null;
                    this.item.plazoSelect = null;
                    
                    this.aceptarCondiciones(false, this.privacidad, this.condiciones, false, false);
                }).finally(() => {
                    this.loading_plazos = false;
                });
            }
        },
        components: { FormTerminos, ResumenPrecioComponnent, AddPlazosComponent }
    };
</script>